import React from "react";
import { Button, Card } from "react-bootstrap";
import { CopyToClipboard, CopiedToClipbard } from '../../../assets';
import { PageBody } from "../../../common/components/PageBody/PageBody";
import { PageMessage } from "../../../common/components/PageMessage/PageMessage";
import { useZerezesServices } from "../../../providers/ZerezesServicesProvider";
import { ExchangePointsRewardOutput } from "../../../domain/services/zclub/member-accounts/ExchangePointsReward/ExchangePointsRewardService";
import { useZerezesClubAccount } from "../../../providers/ZerezesClubAccountProvider";

export const ZClubAccountPageBodyExchangePoints = () => {

  const [message, setMessage] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [exchangeResult, setExchangeResult] = React.useState<ExchangePointsRewardOutput | null | undefined>(null);
  const [couponCodeCopied, setCouponCodeCopied] = React.useState<boolean>(false);

  const {
    ztoken,
    zstore,
    sislogUser,
    memberAccountGroupData,
    cancelExchangePointsReward,
    pointsExchangeReward,
    refresh
  } = useZerezesClubAccount();

  const {
    exchangePointsRewardService,
  } = useZerezesServices();

  return (
    <PageBody>
      {message &&
        <div style={{ marginBottom: '10px' }}><PageMessage text={message} /></div>}

      {exchangeResult?.errorMessage &&
        <div style={{ marginBottom: '10px' }}><PageMessage text={exchangeResult?.errorMessage} /></div>}

      {exchangeResult?.success && exchangeResult?.couponCode && (
        <Card>
          <Card.Body>
            <div style={{ marginBottom: '1rem' }}>
              Uhul! Cupom resgatado com sucesso! <br />
              Agora, clique em copiar e depois aplique no PDV.
            </div>
            <div>
              <button
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center',
                  padding: '1rem', border: '1px solid #000', borderRadius: '4px',
                  backgroundColor: '#fff', color: '#000',
                  width: '150px', cursor: 'pointer'
                }}
                onClick={handleCopyCouponCodeToClipboard}
              >
                <div style={{ fontWeight: 'bold', marginBottom: '0.2rem', fontSize: '1.1em' }}>
                  {pointsExchangeReward?.discountPercentage}% off
                </div>
                <div style={{ marginBottom: '1rem', fontSize: '0.65em', color: '#000' }}>
                  valido até {exchangeResult?.formattedCouponExpirationDate || '...'}
                </div>
                {couponCodeCopied ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={CopiedToClipbard} alt="Cupom copiado" style={{ width: '24px', height: '24px' }} />
                    <span style={{ marginLeft: '0.2rem', fontSize: '0.75em' }}>cupom copiado</span>
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={CopyToClipboard} alt="Copiar cupom" style={{ width: '24px', height: '24px' }} />
                    <span style={{ marginLeft: '0.2rem', fontSize: '0.75em' }}>copiar cupom</span>
                  </div>
                )}
              </button>
            </div>
            <div style={{ marginTop: '1rem' }}>
              <button style={{
                backgroundColor: '#fff', border: 'none', padding: '0', cursor: 'pointer',
                color: '#796914', textDecoration: 'underline'
              }}
                onClick={refresh}
              >voltar para a conta do cliente</button>
            </div>
          </Card.Body>
        </Card>
      )}

      {!exchangeResult && (
        <Card>
          <Card.Body>
            {loading ? (
              <div>Aguarde...</div>
            ) : (
              <>
                <div style={{ marginBottom: '1rem' }}>
                  Deseja trocar <strong>{pointsExchangeReward?.pointsRequired}</strong> pontos
                  por um cupom de <strong>{pointsExchangeReward?.discountPercentage}%</strong> de desconto?
                </div>
                <div style={{ marginBottom: '2rem', fontStyle: 'italic', fontSize: '0.9em' }}>
                  Os cupons têm validade de 1 mês a partir do resgate ;;)
                </div>
                <div style={{ display: 'flex', gap: '1.5rem', marginTop: '1rem', alignItems: 'flex-start', flexDirection: 'column' }}>
                  <Button style={{ width: '155px' }} onClick={exchange}>
                    sim, trocar agora!
                  </Button>
                  <button style={{
                    backgroundColor: '#fff', border: 'none', padding: '0', cursor: 'pointer',
                    color: '#9e0f0f', textDecoration: 'underline'
                  }}
                    onClick={cancelExchangePointsReward}
                  >não, deixa pra depois</button>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      )}
    </PageBody>
  );

  function exchange() {
    setLoading(true);
    setMessage(null);

    let source = '';
    if (sislogUser) {
      source = `user:${sislogUser}`;
    }
    source += (source ? '|' : '') + (zstore ? `store:${zstore}` : 'store:unknown');

    const exchangePointsRewardInput = {
      shopifyCustomerId: memberAccountGroupData?.memberAccount?.shopifyCustomerId || 0,
      rewardId: pointsExchangeReward?.id || 0,
      source: source
    };

    exchangePointsRewardService?.handle(exchangePointsRewardInput, ztoken || '')
      .then((exchangeResult) => {
        setLoading(false);
        setExchangeResult(exchangeResult?.value);
        if (exchangeResult?.value?.errorMessage) {
          setTimeout(() => refresh(), 8000);
        }
      })
      .catch(() => {
        setLoading(false);
        setExchangeResult({
          success: false,
          couponCode: '',
          couponExpiresAt: null,
          formattedCouponExpirationDate: '',
          errorMessage: 'Não foi possível realizar o resgate. Tente novamente mais tarde e se o problema persistir fale com o time tech zrzs.',
          errorType: null
        });
        setTimeout(() => refresh(), 8000);
      });
  }

  function handleCopyCouponCodeToClipboard() {
    const couponCode = exchangeResult?.couponCode || '';

    setCouponCodeCopied(false);

    navigator.clipboard.writeText(couponCode)
      .then(() => {
        setCouponCodeCopied(true);
        setTimeout(() => {
          setCouponCodeCopied(false);
        }, 3000);
      })
      .catch(() => {
        setMessage('Não foi possível copiar o cupom. Tente novamente e se o problema persistir fale com o time tech zrzs.');
        setTimeout(() => {
          setCouponCodeCopied(false);
        }, 5000);
      });
  }

}